import React from "react"
import cx from "classix"
import GIcon from "../components/GIcon"


export default function IconButton({ className, onClick, ...rest }) {
    return <GIcon
        name="send"
        className={className}
        onClick={onClick}
        {...rest}
    />
}

